import { Component, Inject, inject, ChangeDetectionStrategy } from '@angular/core';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SpinnerComponent } from '@custom-components/general/spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserStore } from '@root/app/store/user.store';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

@Component({
  selector: 'delete-user-dialog',
  imports: [
    MatIconModule,
    MatDialogModule,
    FilledButtonComponent,
    OutlinedButtonComponent,
    TranslateModule,
    SpinnerComponent,
    DialogShellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './delete-user-dialog.component.html',
})
export class DeleteUserDialogComponent {
  readonly userStore = inject(UserStore);
  readonly dialogRef = inject(MatDialogRef<DeleteUserDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);

  userOid: string;
  partnerOid: string;
  currentUserOid: string;
  deleteCurrentUser: boolean;
  isDeleting = false;
  userDeletedSuccess = false;
  userDeletedError = false;

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.partnerOid = data.partnerOid;
    this.userOid = data.userOid;
    this.currentUserOid = data.currentUserOid;
    this.deleteCurrentUser = this.userOid == this.currentUserOid;
  }

  onDelete() {
    this.isDeleting = true;
    let deleteUserObservable = this.userStore.deleteUserFromPartnerMethod(
      this.partnerOid,
      this.userOid,
    );
    deleteUserObservable.subscribe({
      next: () => {
        this.isDeleting = false;
        this.userDeletedSuccess = true;
      },
      error: () => {
        this.isDeleting = false;
        this.userDeletedError = true;
      },
    });
  }
}
